module.exports = __webpack_public_path__ + "img/peoples-s.28cdfa4f.jpg";